import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUrl';

/**
 * CMS-driven "Need Help?" sidebar card (Site Settings → Sidebar - Need Help Box).
 */
function NeedHelpWidget({ settings = {} }) {
  const helpTitle = (settings.help_title || '').trim();
  const helpSubtitle = (settings.help_subtitle || '').trim();
  const helpPhone = (settings.help_phone || settings.site_phone || '').trim();
  const helpBtnText = (settings.help_button_text || '').trim();
  const helpBtnUrl = (settings.help_button_url || '').trim();
  const helpBg = settings.help_bg_image ? getImageUrl(settings.help_bg_image) : '';
  const helpLogo = settings.help_logo ? getImageUrl(settings.help_logo) : '';

  const hasContent = helpTitle || helpSubtitle || helpPhone || helpBtnText;
  if (!hasContent) {
    return null;
  }

  const phoneHref = helpPhone.replace(/[^\d+]/g, '');
  const btnIsInternal = helpBtnUrl.startsWith('/') && !helpBtnUrl.startsWith('//');

  return (
    <div
      className="widget widget_offer"
      style={helpBg ? { background: `url(${helpBg})` } : undefined}
    >
      <div className="offer-banner">
        <div className="offer">
          {helpTitle && <h6 className="box-title">{helpTitle}</h6>}
          {helpLogo && (
            <div className="banner-logo">
              <img src={helpLogo} alt="" />
            </div>
          )}
          {(helpSubtitle || helpPhone) && (
            <div className="offer">
              {helpSubtitle && <h6 className="offer-title">{helpSubtitle}</h6>}
              {helpPhone && (
                <a className="offter-num" href={`tel:${phoneHref}`}>
                  {helpPhone}
                </a>
              )}
            </div>
          )}
          {helpBtnText && helpBtnUrl && (
            btnIsInternal ? (
              <Link to={helpBtnUrl} className="th-btn style2 th-icon">
                {helpBtnText}
              </Link>
            ) : (
              <a href={helpBtnUrl} className="th-btn style2 th-icon" target="_blank" rel="noopener noreferrer">
                {helpBtnText}
              </a>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default NeedHelpWidget;
